import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// // // //

/**
 * Renders an empty state component with a message when no loans are found.
 * Provides an option to clear the current search.
 * @param {Object} props - The component props.
 * @param {string} props.message - The message to display when no loans are found.
 * @param {Function} props.onClear - Function to clear the current search.
 * @returns {JSX.Element} The rendered React component.
 */
export function EmptyState(props: { message: string; onClear?: () => void }) {
    const { message, onClear } = props;

    return (
        <div
            className="
        relative w-full h-full flex flex-col justify-center items-center
        rounded-lg border-2 border-dashed border-slate-400 p-12 text-center text-slate-400"
        >
            <FontAwesomeIcon
                className="mx-auto h-12 w-12"
                icon={faMagnifyingGlass}
            />
            <span className="mt-2 block text-lg font-light">{message}</span>
            {onClear && (
                <button
                    className="mt-4 text-link hover:text-link-hover focus:outline-hidden"
                    onClick={() => onClear()}
                >
                    Clear Search
                </button>
            )}
        </div>
    );
}
